/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { createBrowserHistory } from 'history';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from './api';

const history = createBrowserHistory();
export function handleParams(params, options) {
  const { skip = 0, take = 20, filter } = options;

  if (filter) {
    const arrayNomes = [];
    const filterResult = filter.filter((item) => item !== 'and');
    const checkFilterObject =
      filterResult.length === 3 && typeof filterResult[0] === 'string';

    if (checkFilterObject) {
      const field = filterResult[0];
      const value = filterResult[2];
      params[field] = value;
    } else {
      filterResult.map((item) => {
        if (!arrayNomes.includes(item[0])) {
          if (typeof item[0] === 'object') {
            const field = item[0][0];
            const value = item[0][2];

            params[field] = value;
          } else {
            const field = item[0];
            const value = item[2];

            params[field] = value;
          }
          arrayNomes.push(item[0]);
        }
        return item;
      });
    }
  }

  return {
    ...params,
    skip,
    take,
  };
}

export function handleError(method, error) {
  if (!error?.response) error = { response: { data: false, status: false } };
  const { data, status } = error?.response;
  let message = '';

  if (data) {
    const errorMessage = Object.keys(data.errors).map(
      (key) => data.errors[key]
    );
    // eslint-disable-next-line no-useless-escape
    message = errorMessage.join(',').replace(/\,/, ', ');
  }

  switch (status) {
    case 400:
      message = message || 'Verifique os dados enviados';
      break;
    case 401:
      sessionStorage.clear();
      history.replace('/login');
      break;
    case 404:
      throw Error(`${method} (${status}) - Nenhum registro encontrado!`);
    case 500:
      message = message ?? 'Erro no servidor';
      break;
    default:
      message = 'Erro desconhecido!';
      break;
  }

  if (message && status) throw Error(`${method} (${status}) - ${message}`);

  return error;
}

export default function removerAcentos(newStringComAcento) {
  let string = newStringComAcento.toLowerCase();
  const mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    e: /[\xE8-\xEB]/g,
    i: /[\xEC-\xEF]/g,
    o: /[\xF2-\xF6]/g,
    u: /[\xF9-\xFC]/g,
    c: /\xE7/g,
    n: /\xF1/g,
  };

  for (const letra in mapaAcentosHex) {
    const expressaoRegular = mapaAcentosHex[letra];
    string = string.replace(expressaoRegular, letra);
  }

  return string;
}

export function removerAcentosEspacos(newStringComAcentoEspaco) {
  return newStringComAcentoEspaco.normalize('NFD').replace(/[^a-zA-Zs]/g, '');
}

export function loginByDashboard(token, setLoading) {
  const params = {
    token,
    idModulo: 30,
  };
  api
    .get(`Autenticar/AutenticacaoDashboard?${qs.stringify(params)}`)
    // eslint-disable-next-line consistent-return
    .then((res) => {
      if (res.data.statusCode >= 400 && res.data.statusCode <= 499) {
        return false;
        // eslint-disable-next-line no-else-return
      } else {
        const {
          accessToken,
          nomeUsuario,
          empresa,
          usuarioDesenvolvimento = false,
          usuarioSuporte = false,
          statusCode,
          message,
        } = res.data;
        if (statusCode === 401) {
          toast.error(message);
          // eslint-disable-next-line consistent-return
          return;
        }
        sessionStorage.setItem('@auth/token', accessToken);
        sessionStorage.setItem('@auth/userName', nomeUsuario);
        sessionStorage.setItem('@auth/empresa', empresa);
        sessionStorage.setItem('@auth/usuarioDev', usuarioDesenvolvimento);
        sessionStorage.setItem('@auth/usuarioSup', usuarioSuporte);
      }
    })
    .catch((err) => {
      console.error(err);
      return false;
    })
    .finally(() => setLoading(false));
}
